/* NBN test page: care kit picker, free express bar, live store stock. Works with nbn-pdp.js. */
(function () {
  function money(c) { return '$' + (c / 100).toFixed(2); }

  // Opening hours (from the store widget on the live site). Index 0 = Sunday.
  var HOURS = {
    wk: ['10am – 6pm', '9:30am – 7pm', '9:30am – 7pm', '9:30am – 9pm', '9:30am – 9pm', '9:30am – 9pm', '9:30am – 9pm']
  };
  function brisbaneDay() {
    var name = new Date().toLocaleString('en-AU', { timeZone: 'Australia/Brisbane', weekday: 'long' });
    return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].indexOf(name);
  }

  function init(root) {
    if (root.dataset.npKitReady) return;
    root.dataset.npKitReady = '1';
    var data = JSON.parse(root.querySelector('[data-np-variants]').textContent);
    var select = root.querySelector('select[name="id"]');
    function cur() { return data.filter(function (v) { return String(v.id) === select.value; })[0] || data[0]; }

    // ---------- Care kit ----------
    var kit = root.querySelector('[data-np-kit]');
    var packs = kit ? Array.prototype.slice.call(kit.querySelectorAll('.np-pack')) : [];
    var freeAt = kit ? parseInt(kit.dataset.freeAt, 10) || 15000 : 15000;
    var ship = root.querySelector('[data-np-ship]');
    var cartTotal = 0;
    var justAdded = false;

    function selected() { return packs.filter(function (p) { return p.getAttribute('aria-checked') === 'true'; })[0]; }
    function packAdd(p) { return p ? parseInt(p.dataset.add, 10) || 0 : 0; }
    function toySaving(p) { if (!p || cur().price > Number(p.dataset.toyCutoff || 40000)) return 0; var bundlePercent = Number(p.dataset.bundlePercent || 0); if (bundlePercent > 0) return [cur().price].concat(JSON.parse(p.dataset.addonPrices || '[]')).reduce(function(sum,cents){return sum + Math.round(cents * bundlePercent / 100);},0); var percent = Number(p.dataset.toyPercent || 0); return percent > 0 ? Math.round(cur().price * percent / 100) : 0; }
    function total() { return cur().price + packAdd(selected()) - toySaving(selected()); }

    root._npTotal = function () { return total(); };
    root._npBundleProperties = function () {
      var p = selected(), id = p ? Number(p.dataset.bundleId || 0) : 0;
      if (!id || !toySaving(p)) return null;
      // Same public line-item encoding used by Bundler's storefront integration.
      var chars = 'abcdefghijklmnopqrstuvwxyz0123456789', encoded = '';
      while (id) { encoded = chars.charAt(id % 36) + encoded; id = Math.floor(id / 36); }
      return {_bndlr: encoded + ':b;'};
    };
    root._npExtraItems = function () {
      var p = selected();
      if (!p) return [];
      return JSON.parse(p.dataset.addons || '[]').map(function (id) { var item = {id:id,quantity:1}, props = root._npBundleProperties(); if (props) item.properties = props; return item; });
    };

    function updateBar() {
      if (!ship) return;
      var projected = justAdded ? cartTotal : cartTotal + total();
      var left = freeAt - projected;
      var text = ship.querySelector('[data-np-ship-text]');
      var bar = ship.querySelector('[data-np-ship-bar]');
      if (left <= 0) {
        ship.classList.add('done');
        text.innerHTML = '<b>✓ Free express shipping</b> on this order';
        bar.style.width = '100%';
      } else {
        ship.classList.remove('done');
        text.innerHTML = 'Add <b>' + money(left) + '</b> more for free express shipping';
        bar.style.width = Math.max(4, Math.min(100, projected / freeAt * 100)) + '%';
      }
    }

    function update() {
      var price = cur().price;
      packs.forEach(function (p) {
        var now = p.querySelector('[data-np-pack-price]');
        var was = p.querySelector('[data-np-pack-was]');
        if (now) now.textContent = money(price + packAdd(p) - toySaving(p));
        var shippingLabel = p.querySelector("[data-np-pack-shipping]");
        if (shippingLabel) shippingLabel.hidden = price + packAdd(p) - toySaving(p) < freeAt;
        if (was) { was.textContent = money(price + (parseInt(p.dataset.was, 10) || 0)); if ((Number(p.dataset.toyPercent || 0) > 0 || Number(p.dataset.bundlePercent || 0) > 0)) was.hidden = toySaving(p) === 0; }
        var saving = p.querySelector('[data-np-toy-save]'); if (saving) { saving.textContent = 'Save ' + money(toySaving(p)); saving.hidden = toySaving(p) === 0; }
      });
      var maxSaving = root.querySelector('[data-np-kit-max-save]'); if (maxSaving) {var off = packs.reduce(function(m,p){return Math.max(m,toySaving(p));},0);maxSaving.hidden = off===0;maxSaving.textContent='Save up to '+money(off);}
      var t = total();
      var pending = selected() && selected().dataset.offerPreview === 'true' && toySaving(selected()) > 0;
      Array.prototype.forEach.call(root.querySelectorAll('[data-np-atc]'),function(b){ b.disabled = pending || !cur().available; });
      var main = root.querySelector('[data-np-main-atc]');
      if (main) {
        main.dataset.label = 'Add to cart · ' + money(t);
        var l = main.querySelector('[data-np-atc-label]');
        if (l && cur().available) l.textContent = pending ? 'Offer awaiting activation' : main.dataset.label;
      }
      Array.prototype.forEach.call(root.querySelectorAll('[data-np-total]'), function (el) { el.textContent = money(t); });
      Array.prototype.forEach.call(root.querySelectorAll('square-placement'), function (el) { el.setAttribute('data-amount', (t / 100).toFixed(2)); });
      updateBar();
    }

    packs.forEach(function (p) {
      p.addEventListener('click', function () {
        packs.forEach(function (x) { x.setAttribute('aria-checked', x === p ? 'true' : 'false'); });
        justAdded = false;
        update();
      });
    });
    select.addEventListener('change', function () { justAdded = false; update(); if (stock && stock.open) loadStock(); });

    function refreshCart(after) {
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { cartTotal = c.total_price || 0; justAdded = !!after; updateBar(); })
        .catch(function () {});
    }
    document.addEventListener('np:added', function () { setTimeout(function () { refreshCart(true); }, 1200); });
    refreshCart(false);
    update();

    // ---------- Store stock ----------
    var stock = root.querySelector('[data-np-stock]');
    var day = brisbaneDay();
    if (stock) {
      Array.prototype.forEach.call(stock.querySelectorAll('[data-np-today]'), function (el) {
        var h = HOURS[el.closest('li').dataset.hours];
        if (h && day >= 0) el.textContent = 'Open today ' + h[day];
      });
      stock.addEventListener('toggle', function () { if (stock.open) loadStock(); });
    }
    function setStatus(li, qty) {
      var st = li.querySelector('[data-np-st]');
      st.className = 'np-st ' + (qty >= 3 ? 'in' : qty > 0 ? 'low' : 'out');
      st.textContent = qty >= 3 ? 'In stock' : qty > 0 ? 'Low stock' : 'Out of stock';
    }
    function loadStock() {
      var v = cur();
      var rows = Array.prototype.slice.call(stock.querySelectorAll('[data-loc]'));
      rows.forEach(function (li) { var st = li.querySelector('[data-np-st]'); st.className = 'np-st'; st.textContent = 'Checking…'; });
      fetch(stock.dataset.endpoint + '?variant_id=' + encodeURIComponent(v.id) + '&_=' + Date.now(), { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var map = (d && d.stock) || {};
          var count = 0;
          rows.forEach(function (li) {
            var q = d && d.untracked ? 3 : (parseInt(map[li.dataset.loc], 10) || 0);
            if (q > 0) count++;
            setStatus(li, q);
          });
          var sum = stock.querySelector('[data-np-stock-sum]');
          var stockName = v.title === 'Default Title' ? (root.dataset.npProductTitle || root.querySelector('h1').textContent.trim()) : v.title;
          if (sum) sum.textContent = count ? stockName + ' is in stock at ' + count + (count === 1 ? ' location' : ' locations') : stockName + ' is out of stock in store right now';
        })
        .catch(function () {
          rows.forEach(function (li) { var st = li.querySelector('[data-np-st]'); st.className = 'np-st'; st.textContent = 'Call to check'; });
        });
    }
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-np-section]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
